import React from "react";
import { IconProps } from "./IconProps";
import { NoradIcon } from "../../Models/Generated/NoradIcon";
import * as Components from "/App.Components";
interface Props {
  iconType: NoradIcon;
  iconProps: IconProps;
}

export const getIcon = (iconType: NoradIcon): React.FC<IconProps> | null => {
  switch (iconType) {
    case NoradIcon.None:
      return null;
    case NoradIcon.Pdf:
      return Components.FilePdfIcon;
    case NoradIcon.Doc:
      return Components.FileDocIcon;
    case NoradIcon.Xls:
      return Components.FileXlsIcon;
    case NoradIcon.RightArrow:
      return Components.ArrowRightIcon;
    case NoradIcon.Link:
      return Components.LinkIcon;
    case NoradIcon.Notebook:
      return Components.NotebookIcon;
    case NoradIcon.Student:
      return Components.StudentIcon;
    case NoradIcon.Toolbox:
      return Components.ToolboxIcon;
    case NoradIcon.ChatCircleTextIcon:
      return Components.ChatCircleTextIcon;
  }
};

const Icon: React.FC<Props> = ({ iconType, iconProps }) => {
  const Comp = getIcon(iconType);
  if (!Comp) {
    return null;
  }
  return <Comp {...iconProps} />;
};
export default Icon;
